import Styled from "styled-components";

export const Container = Styled.div`
  padding: 4rem 0;
`;

export const Content = Styled.div`
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
  gap: 3.75rem;
  width: ${(props) => props.theme.width};
  max-width: calc(100% - 2.5rem);
  margin: 0 auto;

  ${(props) => props.theme.breakpoints.up("medium")} {
    max-width: calc(100% - 3rem);
    flex-flow: row;
    align-items: stretch;
  }

  ${(props) => props.theme.breakpoints.up("large")} {
    max-width: calc(100% - 10rem);
  }
`;

export const CardContainer = Styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  gap: 1.25rem;
  border-radius: 1.25rem;
  padding: 2.25rem 1.5rem;
  box-shadow: rgba(3, 3, 3, 0.1) 0px 2px 20px;

  ${(props) => props.theme.breakpoints.up("medium")} {
    flex: 0.5;
  }

  ${(props) => props.theme.breakpoints.up("large")} {
    gap: 2rem;
    padding: 2.25rem;
  }
`;

export const Tagline = Styled.span`
  font-size: 1.125rem;
  font-weight: 900;
  line-height: 1.375rem;
  letter-spacing: -0.2px;

  ${(props) => props.theme.breakpoints.up("medium")} {
    font-size: 1.5rem;
    line-height: 1.875rem;
    text-align: center;
  }
`;

export const Pitch = Styled.div`
  font-size: 1.25rem;
  font-weight: 400;
  line-height: 1.562rem;
  letter-spacing: -0.2px;

  ${(props) => props.theme.breakpoints.up("large")} {
    font-size: 1.624rem;
    line-height: 2rem;
  }

  & > p {
    margin: 1rem 0;
  }

  & > p:first-child {
    margin-top: 0;
  }

  & > p:last-child {
    margin-bottom: 0;
  }
`;

export const Link = Styled.a`
  text-decoration: none;
`;
